import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getCustomer, updateCustomer } from 'slice/customerSlice';
import AdminTable from 'common/AdminTable';
// import { useNavigate } from 'react-router-dom';

const ListCustomer = () => {
    const dispatch = useDispatch()
    const cartData = useSelector((state) => state.customer);
    const [showModal, setShowModal] = useState(false);
    const [refer, setRefer] = useState({})
    const [currentProduct, setCurrentProduct] = useState(null);
    // const navigate = useNavigate()

    useEffect(() => {
        Object.keys(refer).length ? dispatch(getCustomer(refer)) : dispatch(getCustomer())
    }, [dispatch, refer])

    // const handleEditClick = (product) => {
    //     setCurrentProduct(product);
    //     setShowModal(true);
    // };

    const referCheck = (id) => {

        if (id) {
            setRefer({
                id,
                refer: true
            })
        } else {
            setRefer({})
        }



    }

    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentProduct(null);
    };

    // Handle saving the edited product
    const handleSave = () => {
        const formData = new FormData();
        formData.append('id', currentProduct.id);
        formData.append('status', currentProduct.status);
        formData.append('wallet', currentProduct.wallet);
        // Dispatch updateProduct with the formData
        dispatch(updateCustomer({ id: currentProduct.mobile, data: currentProduct }));
        handleCloseModal(); // Close modal after saving
    };

    // Table Headers
    const tableHeaders = [
        {
            Header: 'Name',
            accessor: 'name',
        },

        {
            Header: 'Mobile',
            accessor: 'mobile',
        },
        {
            Header: 'Status',
            accessor: 'is_active',
            Cell: ({ row }) => (
                <>
                    <span className={row.original.is_active ? 'badge badge-success' : 'badge badge-danger'}>
                        {row.original.is_active ? 'Active' : 'Inactive'}
                    </span>
                </>
            )
        },
        {
            Header: 'Join Date',
            accessor: 'createdAt'
        },
          {
            Header: 'City',
            accessor: 'city'
        },
        // {
        //     Header: 'Actions',
        //     accessor: 'actions',
        //     Cell: ({ row }) => (
        //         <>
        //             <button
        //                 className="btn editbtn mx-1 my-1"
        //                 onClick={() => handleEditClick(row.original)} // Correct function
        //             >
        //                 Updated
        //             </button>
        //         </>
        //     ),
        // }
    ];

    return (
        <>
            <div className='container-fluid mt-5'>
                <div className='mainheadig mx-4 d-flex'>
                    <h4 className='text-white font-weight-bold '>User List</h4>
                    <button className="ml-auto btn btn-primary mr-4" onClick={() => referCheck(null)}><i className="fa fa-refresh" aria-hidden="true"></i></button>
                </div>
                {cartData?.data?.length > 0 ? (
                    <AdminTable tableHeaders={tableHeaders} tableData={cartData.data} />
                ) : <p className='container-fluid bg-danger w-100 p-2  mx-4 text-center text-white'>No data found</p>}

                {showModal && currentProduct && (
                    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog" aria-labelledby="editModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="editModalLabel">View User</h5>
                                    <button type="button" className="close" onClick={handleCloseModal} aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <form>
                                        <div className="form-group">
                                            <label htmlFor="status">Action</label>
                                            <select defaultValue={currentProduct.is_active} onChange={(e) => setCurrentProduct({ ...currentProduct, is_active: e.target.value })} className="form-control" id="productStatus">
                                                <option value={true}>Active</option>
                                                <option value={false}>Inactive</option>
                                            </select>
                                        </div>
                                    </form>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>Close</button>
                                    <button type="button" className="btn btn-primary" onClick={handleSave}>Save changes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default ListCustomer;
